import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {makeResource} from '../../../../../../../../utils/makeResource'
import {
  buildProblemsPreviewQuery,
  getBuildProblemsPreviewVariables,
} from '../../../../../../../packages/BuildProblems/BuildProblemsPreview/BuildProblemsPreview.queries'
import {
  getCountsVariables,
  testsPreviewPanelCountsQuery,
} from '../../../../../../../packages/Tests/TestsPreviewPanel/TestsPreviewPanel.queries'

import type {OverviewTabComponent} from './OverviewTab'

export const OverviewTabEntryPoint: EntryPoint<OverviewTabComponent, string> = {
  root: makeResource(
    'OverviewTab',
    () => import(/* webpackChunkName: "OverviewTab" */ './OverviewTab'),
  ),
  getPreloadProps: buildLocator => ({
    queries: {
      testCounts: {
        parameters: getRequest(testsPreviewPanelCountsQuery),
        variables: getCountsVariables(buildLocator),
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
      buildProblemsPreview: {
        parameters: getRequest(buildProblemsPreviewQuery),
        variables: getBuildProblemsPreviewVariables(buildLocator),
      },
    },
  }),
}
